import type { JSX } from "react";

import { useChallenges } from "@/sales-tools/challenges/api/useChallenges";
import { findUnackedAnnouncements } from "@/sales-tools/challenges/utils/findUnackedAnnouncements";
import { useLogger } from "@/sdk";

import { AnnouncementEnd } from "./component/AnnouncementEnd/AnnouncementEndCard";
import { AnnouncementStartFactory } from "./component/AnnouncementStart/AnnouncementStartFactory";

export function Announcement(): (JSX.Element[] | undefined)[] | undefined {
    const logger = useLogger({ module: "Announcement", supportTeam: "sales" });
    const { data: challenges, isLoading, isError, isFetching } = useChallenges();

    if (isLoading || isError || !challenges || isFetching) return undefined;

    const unacked = findUnackedAnnouncements(logger, challenges);

    return [
        unacked?.ackEnds.map((a) => <AnnouncementEnd key={a.challengeId} challenge={a} />),
        unacked?.ackStarts.map((a) => <AnnouncementStartFactory key={a.challengeId} challenge={a} />).reverse(),
    ];
}
